
export const urlWithContour = () => {
  const url = window.location.origin
  const demo = url.includes('demo.') ? 'demo.' : ''
  const contour =  url.includes('dev.')
    ? 'dev.' : url.includes('stage.')
    ? 'stage.' : url.includes('localhost')
    ? 'dev.' : ''
  return 'https://' + contour + demo + 'lfqr.cc'
}
